module.exports = __webpack_public_path__ + "img/huawei_06.816d8369.jpg";